import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L7 7L13 1", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDown);
const Memo = memo(ForwardRef);
export default Memo;
